import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/** Alert, title and the events paper, as in P05. */
const AccountStatusSkeleton = () => (
  <Stack gap={3} aria-busy="true">
    <Skeleton variant="rounded" height={72} />
    <Skeleton variant="text" width="30%" height={36} />
    <Skeleton variant="rounded" height={220} />
  </Stack>
);

export default AccountStatusSkeleton;
